enum DigitalProgramPreviewConsumer {
    BackOffice = 'back-office',
    Browser = 'browser',
    Widget = 'widget',
    Mobile = 'mobile',
}

export default DigitalProgramPreviewConsumer;
